import React from 'react'
import "./BodyPart.css";
import {Avatar} from "@material-ui/core";
import Story from "./Story";
import Widgets from "./Widgets";
import Posts from "./Posts";

function BodyPart() {
    return (
        <div className="bodyPart">

            <div className="leftPart">
            <div className="story">

        <Story/>
      
                </div>

                <div className="posts">
            <Posts/>
                    </div>
</div>

                <div className="rightPart">
                <Widgets/>
                    </div>
            
        </div>
    )
}

export default BodyPart
